import React from 'react';
import { FaTwitch } from 'react-icons/fa';

/**
 * Enveloppe du contenu nécessitant une authentification Twitch.
 * Quand Twitch n'est pas connecté : floute le contenu et affiche un message invitant à s'authentifier.
 * @param {Object} props
 * @param {React.ReactNode} props.children - Contenu à afficher
 * @param {Object|null} props.twitchUser - Utilisateur Twitch connecté (null si non connecté)
 * @param {Function} props.onConnect - Callback pour lancer la connexion Twitch
 */
function TwitchAuthGate({ children, twitchUser, onConnect }) {
  const isAuthenticated = twitchUser != null && (twitchUser.id || twitchUser.user_id);

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="twitch-auth-gate">
      <div className="twitch-auth-gate-content twitch-auth-gate-blurred">
        {children}
      </div>
      <div className="twitch-auth-gate-overlay">
        <div className="twitch-auth-gate-message">
          <FaTwitch className="twitch-auth-gate-icon" aria-hidden />
          <p>Connectez-vous avec Twitch pour accéder à ce contenu</p>
          {onConnect && (
            <button
              type="button"
              className="twitch-auth-gate-button"
              onClick={onConnect}
            >
              <FaTwitch />
              Connecter Twitch
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default TwitchAuthGate;
